import { MazeFlowCanvas } from '@/apps/maze/MazeFlowCanvas';
import type { AppEdge, AppNode, NodeKind } from '@/flow/types';
import type { LearningFlow } from './learningTypes';
import type { FlowDisplayLanguage } from '@/flow/displayLanguage';

const NO_BLOCKED_NODES: ReadonlySet<string> = new Set();

type LearningFlowCanvasProps = {
  stageId: number;
  displayLanguage: FlowDisplayLanguage;
  initialFlow: LearningFlow;
  availableNodeKinds: readonly NodeKind[];
  addRequestKind: NodeKind | null;
  onAddHandled: () => void;
  onFlowChange: (nodes: AppNode[], edges: AppEdge[]) => void;
  onPersistFlow: (nodes: AppNode[], edges: AppEdge[]) => void;
  activeNodeIds: ReadonlySet<string>;
  activeEdgeIds: ReadonlySet<string>;
};

export function LearningFlowCanvas(props: LearningFlowCanvasProps) {
  return (
    <MazeFlowCanvas
      stageId={props.stageId}
      displayLanguage={props.displayLanguage}
      initialFlow={props.initialFlow}
      allowedNodeKinds={props.availableNodeKinds}
      ensureInitialFit
      addRequestKind={props.addRequestKind}
      onAddHandled={props.onAddHandled}
      onFlowChange={props.onFlowChange}
      onPersistFlow={props.onPersistFlow}
      activeNodeIds={props.activeNodeIds}
      blockedNodeIds={NO_BLOCKED_NODES}
      activeEdgeIds={props.activeEdgeIds}
    />
  );
}